import { useEffect, useState } from 'react';
import { useFormContext } from '../contexts/form';

const useForm = (form) => {
  const [formData, setFormData] = useState(form);
  const { formSetValue, formReset } = useFormContext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => formReset(), []);

  const changeFormData = (newFormData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newFormData,
    }));

    Object.entries(newFormData).forEach(([key, value]) => {
      formSetValue(key, value);
    });
  };

  const handleOnChange = (event) => {
    changeFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleOnChangeFile = (event) => {
    changeFormData({
      ...formData,
      [event.target.name]: event.target.files,
    });
  };

  const handleOnChangeCode = (value) => {
    setFormData({
      ...formData,
      code: value,
    });

    formSetValue('code', value);
  };

  const handleChangeRange = (event) => {
    changeFormData({
      ...formData,
      [event[0].target.name]: event[0].target.value,
      [event[1].target.name]: event[1].target.value,
    });
  };

  const resetFormData = () => {
    formReset();
    setFormData(form);
  };

  const handleOnChangeCheckbox = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.checked,
    });
  };

  const handleOnChangeCustom = (event, id) => {
    const auxFormData = formData;

    if (event.target.checked) {
      if (event.target.name.startsWith('all')) {
        Object.entries(auxFormData[id]).forEach(([key]) => {
          auxFormData[id][key] = false;
        });
      } else {
        auxFormData[id][`all${id}`] = false;
      }
    }
    auxFormData[id][event.target.name] = event.target.checked;

    setFormData({
      ...formData,
      ...auxFormData,
    });
  };

  return {
    formData,
    setFormData,
    resetFormData,
    changeFormData,
    handleOnChange,
    handleChangeRange,
    handleOnChangeCode,
    handleOnChangeFile,
    handleOnChangeCustom,
    handleOnChangeCheckbox,
  };
};

export default useForm;
